import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"idleStage"},[_c('span',{staticClass:"upperContent"},[_c('span',{staticClass:"statusText"},[_c(VIcon,{attrs:{"color":"warning","left":""}},[_vm._v("status_warning")]),_c('span',[_vm._v(_vm._s(_vm.$t("Onboarding.licenseServer.idle")))])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }